import { render, staticRenderFns } from "./roleVoiceManage.vue?vue&type=template&id=77ef0064&scoped=true"
import script from "./roleVoiceManage.vue?vue&type=script&lang=ts"
export * from "./roleVoiceManage.vue?vue&type=script&lang=ts"
import style0 from "./roleVoiceManage.vue?vue&type=style&index=0&id=77ef0064&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef0064",
  null
  
)

export default component.exports